import { Link } from 'react-router-dom';
import { api, Product } from '../api';
import { useLoad } from '../Components/ui';

const offers = [
    {
        title: "WordPress Hosting",
        text: "WordPress, ready to go: pre-installed, with automatic SSL and your own WP-Admin account.",
        items: ["WordPress pre-installed", "5 GB storage", "One-click login to WP-Admin"],
        from: "149 kr/mo",
        category: "wordpress",
    },
    {
        title: "Static Web Hosting",
        text: "Lightning fast hosting for static sites and SPAs, served from the CarbonEdge network.",
        items: ["Edge caching", "SFTP access", "Free SSL certificates"],
        from: "from 49 kr/mo",
        category: "static",
    },
    {
        title: "Domains & DNS",
        text: "Register or transfer your .se or .com domain and manage every DNS record from one simple panel.",
        items: [".se and .com domains", "Transfer with auth code", "Full record management"],
        from: "from 29 kr/mo",
        category: "domain",
        // Only shown while domain or DNS plans are for sale (they depend on CarbonEdge support).
        requires: ["domain", "dns"],
    },
];

export default function HostingPromo() {
    const { data: products } = useLoad(() => api.get<{ products: Product[] }>('/products').then(r => r.data.products), []);
    const categories = new Set(products?.map(p => p.category) ?? []);
    const visible = offers.filter(o => !o.requires || o.requires.some(c => categories.has(c as Product['category'])));

    return (
        <section className="section">
            <span className="section-label">Hosting by Forget-IT</span>
            <h2>Web hosting you can forget about</h2>
            <p className="section-desc">
                Fast, secure hosting on our own CarbonEdge infrastructure. We keep your site online, updated and backed up — you just publish.
            </p>

            <div className="promo-banner" data-aos="fade-up">
                <div>
                    <h3>Launch your site today</h3>
                    <p>Pick a plan, pay with Swish and your hosting is set up automatically within minutes — DNS, SSL and all.</p>
                </div>
                <Link className="hero-cta" to="/hosting">Explore hosting →</Link>
            </div>

            <div className={`card-grid cols-${visible.length}`}>
                {visible.map((offer, i) => (
                    <Link to={`/hosting#${offer.category}`} className="card-item" key={offer.title} data-aos="fade-up" data-aos-delay={i * 100} style={{ textDecoration: 'none' }}>
                        <h3>{offer.title}</h3>
                        <p className="card-text">{offer.text}</p>
                        <ul>
                            {offer.items.map(item => <li key={item}>{item}</li>)}
                        </ul>
                        <div className="price-from">{offer.from}</div>
                    </Link>
                ))}
            </div>
        </section>
    );
}
